import { render } from "./FormSpinner.vue?vue&type=template&id=0e64c0ae&scoped=true"
const script = {}

import "./FormSpinner.vue?vue&type=style&index=0&id=0e64c0ae&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e64c0ae"]])

export default __exports__